$(document).ready(function () {

    
    $('.c-content-block').each(function(index){
        if(index == 0){
            $(this).addClass('is-active');
        }
    })
    $('.c-exp-tabs__item-btn').click(function(){
        var $dataTab = $(this).data('tab');
        $('.c-content-block').removeClass('is-active');
        $('#'+$dataTab).addClass('is-active');
    })

    $('.c-content-block__carousel-block').each(function(i){
        var dataID = $(this).data('id');
        var swiper = new Swiper(`.c-content-block__carousel-block--${dataID}` , {
            // Optional parameters
            loop: true,
            loopAdditionalSlides: 10,
            centeredSlides: true,
            slidesPerView: '1',
            spaceBetween: 40,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: '1',
                    spaceBetween: 10,
                },
                // when window width is >= 480px
                899: {
                    slidesPerView: '1',
                    spaceBetween: 40,
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: (`.c-content-block__button-next--${dataID}`),
                prevEl: (`.c-content-block__button-prev--${dataID}`),
            }
        });
    })
})